import React from 'react';
import HomeAfter from '../views/homeafter';
import { element } from 'prop-types';
import About from '../views/About';
import TermsConditions from '../views/TermsConditions';
import PrivacyPolicy from '../views/PrivacyPolicy';
import Activities from '../views/Activities';

const routes = [
  { path: '/', element: <HomeAfter /> },
  { path: '/about', element: <About /> },
  { path: '/terms-conditions', element: <TermsConditions /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
  { path: '/activities', element: <Activities /> },
];

export default routes;
